export const MODULE_NAME = 'cart';
export const USER_VALIDATION = {
  VALID: 'VALID',
};

export const DNI_USER_VALID_STORAGE = 'DNI_USER_VALID';

export const DELIVERY_FEE = 'DELIVERY_FEE';
export const PERCENTAGE = 'PERCENTAGE';
export const FIXED = 'FIXED';
export const SATURATED = 'SATURATED';
